import PropTypes from 'prop-types';
import Select from 'react-select';
import React, { useState, useEffect } from 'react';
import includes from 'lodash/includes';
import isArray from 'lodash/isArray';
import isUndefined from 'lodash/isUndefined';

const styles = {
  input: (style) => ({
    ...style,
    paddingTop: 16,
    paddingBottom: 16,
    '@media (min-width: 900px)': {
      ...styles['@media (min-width: 900px)'],
      paddingTop: 4,
      paddingBottom: 4,
    },
  }),
  menu: (style) => ({
    ...style,
    zIndex: 99,
  }),
};

function MultiSelect({
  options, handleChange, value, isDisabled, placeholder, isSingle, onMenuOpen,
}) {
  const selectionValue = options.filter((selection) => includes(value, selection.value));
  const [selected, setSelected] = useState(selectionValue);

  useEffect(() => {
    setSelected(options.filter((selection) => includes(value, selection.value)));
  }, [value]);

  function handleSelection(newSelections) {
    setSelected(newSelections);
    if (isArray(newSelections)) {
      handleChange(newSelections.map((selectObject) => selectObject.value));
    } else if (newSelections === null) {
      handleChange();
    } else if (newSelections) {
      handleChange(newSelections.value);
    }
  }

  const isMultiSelect = isUndefined(isSingle) || !isSingle;

  const displayScrollableList = selected && isArray(selected) && selected.length > 50;
  const scrollContainerStyles = displayScrollableList && {
    valueContainer: (style) => ({
      ...style,
      minHeight: '255px',
      height: '80px',
      overflowY: 'scroll',
    }),
  };

  return (
    <Select
      value={selected}
      onChange={handleSelection}
      isSearchable
      isMulti={isMultiSelect}
      isDisabled={isDisabled}
      placeholder={placeholder}
      options={options}
      styles={{ ...styles, ...scrollContainerStyles }}
      onMenuOpen={onMenuOpen}
    />
  );
}

MultiSelect.defaultProps = {
  placeholder: '',
  value: [],
  isDisabled: false,
  onMenuOpen: () => {},
};
MultiSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    isDisabled: PropTypes.bool,
  })).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  isDisabled: PropTypes.bool,
  onMenuOpen: PropTypes.func,
};

export default MultiSelect;
